import { AxDropdown } from "@axess/limestone";
import { AxInit, ModuleName } from "../../../Lib/AxSystem/AxInit";
import { AxLoad } from "../../../Lib/AxSystem/AxLoad";
import { AxLoading } from "../../../Limestone/AxLoading/AxLoading";
import { CompPackOrderLessonProgramValues } from "../../../Models/ComplexPackages/BookingOptions/CompPackOrderLessonProgramValues";
import { ComplexPackageBookingOptions } from "../ComplexPackageBookingOptions";
import { addUniqueObjectToArray } from "../../../Lib/Helper/ObjectHelper";

@ModuleName("CompPackBookingLessonProgramOptions")
export class CompPackBookingLessonProgramOptions implements AxInit {
    private cpBookingOptions: ComplexPackageBookingOptions = AxLoad.GetModule<ComplexPackageBookingOptions>('ComplexPackageBookingOptions');
    private lessonProgramSlotDropdown = new AxDropdown();
    private axLoading: AxLoading = new AxLoading();

    AxInit(init: initData): void {
        const lessonPrograms = JSON.parse(init.lessonPrograms && init.lessonPrograms !== '' ? init.lessonPrograms : '[{}]');
        lessonPrograms.forEach(() => {
            this.lessonProgramSlotDropdown.init('.prod_selection__lessonProgramSlot-selection .ax-dropdown', {
                searchBar: false,
                multiSelect: false,
                onSelect: () => {
                    const $selected = this.lessonProgramSlotDropdown.getSelected();
                    this.onLessonProgramSlotSelected($selected);
                },
            });
            this.cpBookingOptions.dropDowns = addUniqueObjectToArray(this.cpBookingOptions.dropDowns, this.lessonProgramSlotDropdown, 'selector');
        });
    }

    onLessonProgramSlotSelected($currentSelected) {
        if ($currentSelected.length === 0) {
            return;
        }
        const lessonProjNr = Number($currentSelected.attr('data-lessonProjNr'));
        const lessonGroupNr = Number($currentSelected.attr('data-lessonGroupNr'));
        const lessonGroupDefNr = Number($currentSelected.attr('data-lessonGroupDefNr'));
        const lessonProgramProjNr = Number($currentSelected.attr('data-lessonProgramProjNr'));
        const lessonProgramGroupNr = Number($currentSelected.attr('data-lessonProgramGroupNr'));
        const lessonProgramNr = Number($currentSelected.attr('data-lessonProgramNr'));

        const lessonProgramValues = new CompPackOrderLessonProgramValues(
            lessonProjNr, lessonGroupNr, lessonGroupDefNr,
            lessonProgramNr, lessonProgramProjNr, lessonProgramGroupNr
        );

        this.loadSelectedLessonProgramSlots(lessonProgramValues);
        this.cpBookingOptions.bookingValuesList.forEach((bookingValues) => {
            bookingValues.lessonProgramOrderValues = [lessonProgramValues];
        });
    }

    loadSelectedLessonProgramSlots(lessonProgramValues: CompPackOrderLessonProgramValues) {
        const $timeSlotData = $('.selectedSlotHolder');
        const data = {
            lessonProjNr: lessonProgramValues.lessonProjNr,
            lessonGroupNr: lessonProgramValues.lessonGroupNr,
            lessonDefNr: lessonProgramValues.lessonDefNr,
            lessonProgramNr: lessonProgramValues.lessonProgramNr,
            lessonProgramProjNr: lessonProgramValues.lessonProgramProjNr,
            lessonProgramGroupNr: lessonProgramValues.lessonProgramGroupNr
        }
        this.axLoading.ShowLoadingIndicator($timeSlotData?.get(0));
        AxessViewer.loadPartialView('/ComplexPackagesBooking/GetSelectedLessonProgramSlotsPartial', data, (result: string) => {
            $timeSlotData.html(result);
            this.axLoading.HideLoadingIndicator($timeSlotData?.get(0));
        }, {
            dataType: 'html',
        });
    }
}

export interface initData {
    languageId: number;
    lessonPrograms: string;
}
